<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <el-form ref="formValidate" :model="model" :rules="rules" label-width="320px">
                    <el-form-item label="公众号菜单：" prop="content">
                        <el-input v-model="model.content" type="textarea" :rows="10" style="width: 680px" ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSubmit" size="medium">保 存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import { getSysConfig, saveMenu } from '@/api/sysconfig'

export default {
    name: "subMenu",
    data() {
        return {
            model: {
                content: '',
            },
            rules: {
                content: [
                    {required: true, message: '公众号菜单不能为空', trigger: 'blur'},
                ]
            }
        }
    },
    mounted(){
        this.getData()
    },
    methods: {
        getData(){
            getSysConfig().then(res=>{
                if(res.code ==1){
                    this.model.content = res.data.menu_str
                }
            })
        },
        handleSubmit(){
            this.$refs['formValidate'].validate((valid) => {
                if (valid) {
                    saveMenu(this.model.content).then(res=>{
                        if(res.code ==1){
                            this.$msgs("保存成功！");
                        }else{
                            this.$msg(res.msg)
                        }
                    })
                }
            })
        }
    }
}
</script>